import { Decimal, type DecimalInput } from '@app/shared';

const GROUPED_FORMATTER = new Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const QTY_FORMATTER = new Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 3,
});

/** Locale-grouped display string, e.g. "1 234,50" (+ " KGS" if `currency` is given). Display
 *  only — never feed the result back into a calculation, always round-trip the original Decimal
 *  or wire string for that. */
export function formatMoney(value: DecimalInput, currency?: string): string {
  const formatted = GROUPED_FORMATTER.format(new Decimal(value).toNumber());
  return currency ? `${formatted} ${currency}` : formatted;
}

/** Locale-grouped quantity display, trimming trailing zeros (e.g. "12" not "12,000"). */
export function formatQty(value: DecimalInput, unit?: string): string {
  const formatted = QTY_FORMATTER.format(new Decimal(value).toNumber());
  return unit ? `${formatted} ${unit}` : formatted;
}
